import React, { Component } from "react";
import { ProcedureAdministrationView } from "../../views";
import { LocalStorageService, ProceduresService } from "../../../services";

class ProcedureAdministrationAction extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoadingView: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            procedures: [
                {
                    name: 'Permiso',
                    startDate: '2023-11-27 16:04:38.087117',
                    entity: 'Entidad Sanatander',
                    finishDate: '2024-05-27 16:04:38.087117',
                    status: 'Carga de datos',
                    completeDate: 'Fecha de inicio el 12-nov-2023',
                    dateConvertFinish: '27-ago-2024',
                },
                {
                    name: 'Visa laboral permanente',
                    startDate: '2024-01-27 16:04:38.087117',
                    entity: 'Entidad BBVA',
                    finishDate: '2024-06-25 16:04:38.087117',
                    status: 'Validación',
                    completeDate: 'Fecha de inicio el 27-ene-2024',
                    dateConvertFinish: '25-jun-2024',
                },
                {
                    name: 'Residencia inversionista',
                    startDate: '2023-05-02 16:04:38.087117',
                    entity: 'Juan Flores',
                    finishDate: '2024-04-12 16:04:38.087117',
                    status: 'Autorización',
                    completeDate: 'Fecha de inicio el 02-ago-2023',
                    dateConvertFinish: '12-abr-2024',
                },
                {
                    name: 'Permiso laboral',
                    startDate: '2023-12-05 16:04:38.087117',
                    entity: 'Entidad Sanatander',
                    finishDate: '2024-12-22 16:04:38.087117',
                    status: 'Carga de datos',
                    completeDate: 'Fecha de inicio el 05-dic-2023',
                    dateConvertFinish: '22-dic-2024',
                },
                {
                    name: 'Permiso',
                    startDate: '2023-06-25 16:04:38.087117',
                    entity: 'Entidad Sanatander',
                    finishDate: '2024-10-22 16:04:38.087117',
                    status: 'Carga de datos',
                    completeDate: 'Fecha de inicio el 25-jul-2023',
                    dateConvertFinish: '22-oct-2024',

                },
                {
                    name: 'Permiso laboral',
                    startDate: '2023-06-25 16:04:38.087117',
                    entity: 'Entidad Sanatander',
                    finishDate: '2024-10-25 16:04:38.087117',
                    status: 'Carga de datos',
                    completeDate: 'Fecha de inicio el 25-jul-2023',
                    dateConvertFinish: '25-sep-2024'
                },
                {
                    name: 'Permiso',
                    startDate: '2023-06-25 16:04:38.087117',
                    entity: 'Entidad Sanatander',
                    finishDate: '2024-10-10 16:04:38.087117',
                    status: 'Carga de datos',
                    completeDate: 'Fecha de inicio el 25-jul-2023',
                    dateConvertFinish: '10-sep-2024'

                }
            ],
            proceduresTypes: [ 
                {
                    name: 'Todos',
                    id: 0
                }
            ]
        }
    }

    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService()
    proceduresService = new ProceduresService(this.url)

    async componentDidMount(){
        // this.toggleLoadingView(true)
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user");
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo)
                    }
                }
            }, time || 4000)
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo);
                    }
                }
            }, time || 4000)
        })
    }

    createProcedure = async(data, handleShowPrincipalView, handleCleanInputs) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al crear el trámite'
        let { nameProcedure, procedureUserId, statusApplicationTypeId, startDate, limitDate } = data

        try {
            let procedure = await this.proceduresService.createProcedure(nameProcedure, procedureUserId, statusApplicationTypeId, startDate, limitDate, this.token)
            if(procedure && procedure.data && Number(procedure.statusCode) === 200){
                this.toggleLoadingRequesting(false)
                handleCleanInputs()
                handleShowPrincipalView()
            }else if(Number(procedure.statusCode) === -5){
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }else{  
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    render(){
        return(
            <ProcedureAdministrationView
                {...this.state}
                {...this.props}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}

                createProcedure={this.createProcedure}
            />
        )
    }
}

export { ProcedureAdministrationAction as default }